import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API_BASE = `${BACKEND_URL}/api`;
export const PORTAL_TOKEN_KEY = "kto_customer_token";

export const portalApi = axios.create({
  baseURL: PORTAL_API_BASE,
  headers: { "Content-Type": "application/json" },
});

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatPortalError(detail, fallback = "Something went wrong.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
